import { createRouter, createWebHistory } from "vue-router";
import { watch }            from "vue";
import { useAuthStore }     from "../stores/authStore";
import MainLayout        from "../layout/MainLayout.vue";
import Login             from "../components/Login.vue";
import DashboardView     from "../components/DashboardView.vue";
import SessionsView      from "../components/SessionsView.vue";
import RecordingsView    from "../components/RecordingsView.vue";
import Settings          from "../components/Settings.vue";
import InvestigationView from "../components/InvestigationView.vue";

const routes = [
  {
    path:      "/login",
    name:      "login",
    component: Login,
  },
  {
    path:      "/",
    component: MainLayout,
    meta:      { requiresAuth: true },
    children: [
      { path: "",               name: "home",          component: DashboardView  },
      { path: "dashboard",      name: "dashboard",     component: DashboardView  },
      { path: "sessions",       name: "sessions",      component: SessionsView   },
      { path: "recordings",     name: "recordings",    component: RecordingsView },
      { path: "settings",       name: "settings",      component: Settings       },
      {
        path:  "investigation/:id",
        name:  "investigation",
        component: InvestigationView,
        props: true,
      },
    ],
  },
  { path: "/:pathMatch(.*)*", redirect: "/" },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();

  // Wait for Firebase to restore auth state before making any decision
  if (!authStore.isAuthReady) {
    await new Promise((resolve) => {
      const stop = watch(
        () => authStore.isAuthReady,
        (ready) => { if (ready) { stop(); resolve(); } }
      );
    });
  }

  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    return next("/login");
  }

  if (to.path === "/login" && authStore.isAuthenticated) {
    return next("/");
  }

  next();
});

export default router;